var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"breadcrumb"},[_vm._t("header",function(){return [_c('h1',[_vm._v(_vm._s(_vm.page))])]})],2),_vm._v(" "),_c('div',{staticClass:"separator-breadcrumb border-top"})])
}
var staticRenderFns = []

export { render, staticRenderFns }